import AScene from '../../library/ExtendedObjects/AScene.js';
import gameData from '../../gameData.js';
import Grid from '../tiles/grid.js';
import Popup from './Popup.js';
import Phaser from 'phaser';
import ABCyaPhaser from '@abcya/abcya_phaser';

export default class Game extends AScene {
  static get KEY() {return 'Game';};

  create() {
    gameData.currentScene = 'Game';
    gameData.gameOver = false;
    gameData.gamePaused = false;
    gameData.moves = 0;
    gameData.shuffleCounter = gameData.initShuffleCounter;

    this.startX;
    this.startY;
    this.endX;
    this.endY;
    this.selectedCell;

    this.bg = this.addImage(this.mid.x, this.mid.y, `${gameData.gameStyle}_BG`);

    this.grid = new Grid(this, 10, null);
    this.addToParent(this.grid, this);

    this.createNav();
    this.popup = new Popup(this, 'instruct');
    this.addToParent(this.popup, this);

    this.input.on(Phaser.Input.Events.GAME_OUT, (time, event) => {
      if (event instanceof MouseEvent) {
        this.input.manager.onMouseUp(event);
      }
    });
  }

  createNav() {
    // console.log("creating navBar");

    this.resetBtn = this.addButton(105, 940, `${gameData.gameStyle}_Btn_Restart`, {}, () => {this.resetGrid();});
    this.helpBtn = this.addButton(665, 940, `${gameData.gameStyle}_Btn_Hlp`, {}, () => {this.pauseGame();});

    let tinter;
    if (gameData.gameStyle === 'Uncrn') {
      tinter = '0x5c3dcc';
    }
    else if (gameData.gameStyle === 'Wntr') {
      tinter = '0x0094c9';
    }
    else if (gameData.gameStyle === 'Wood') {
      tinter = '0xe4d0b0';
    }
    else if (gameData.gameStyle === 'Atm') {
      tinter = '0x8e2121';
    }
    else {
      tinter = '0xFFFFFF';
    }
    const moveBG = this.addText(this.mid.x, 970, 30, tinter, gameData.styleFont, ABCyaPhaser.Localization.instance.getLocalizedString("game_screen.moves_label"), this, true);
    this.moves = this.addText(this.mid.x, 915, 60, tinter, gameData.styleFont, gameData.moves, this, true);

    this.disableNav();
  }

  enableNav() {
    // console.log("nav enabled");
    this.resetBtn.setEnabled(true);
    this.helpBtn.setEnabled(true);
  }

  disableNav() {
    // console.log("nav disabled");
    this.resetBtn.setEnabled(false);
    this.helpBtn.setEnabled(false);
  }

  enableSwipe() {
    // console.log("swipe enabled");
    this.input.on('pointerdown', (pointer) => {this.beginSwipe(pointer);});
    this.input.on('pointerup', (pointer) => {this.endSwipe(pointer);});
  }

  disableSwipe() {
    // console.log("swipe disabled");
    this.input.off('pointerdown');
    this.input.off('pointerup');
  }

  beginSwipe(pointer) {
    // console.log("DOWN");
    this.startX = pointer.x;
    this.startY = pointer.y;

    this.selectedCell = null;

    for (let r = 0; r < this.grid.nodes.length; r++) {
      const dist = Phaser.Math.Distance.Between(this.grid.nodes[r].x, this.grid.nodes[r].y, pointer.x, pointer.y);

      if (dist <= 50) {
        // console.log(this.grid.nodes[r].tile.char);
        this.selectedCell = this.grid.nodes[r];
      }
    }

    if(this.selectedCell != null) this.selectedCell.tile.scale = 1.10;
  }

  endSwipe(pointer) {
    // console.log("UP");
    // saving mouse/finger coordinates
    this.endX = pointer.x;
    this.endY = pointer.y;

    // determining x and y distance travelled by mouse/finger from the start
    // of the swipe until the end
    const distX = this.startX - this.endX;
    const distY = this.startY - this.endY;

    let reset = true;

    // in order to have an horizontal swipe, we need that x distance is at least twice the y distance
    // and the amount of horizontal distance is at least 10 pixels
    if (this.selectedCell && !this.selectedCell.tile.isBlank) {
      if (Math.abs(distX) > Math.abs(distY) * 2 && Math.abs(distX) > 10) {
        if (distX > 0) {
          const adjCell = this.selectedCell.calculateAdjacentCells(null, 'left');

          if (adjCell!=null&& adjCell.tile.isBlank) {
            // console.log("BLANK TILE LEFT");
            this.selectedCell.swapTile(adjCell, true);
            reset = false;
          }
        }
        else {
          const adjCell = this.selectedCell.calculateAdjacentCells(null, 'right');

          if (adjCell!=null&&adjCell.tile.isBlank) {
            // console.log("BLANK TILE RIGHT");
            this.selectedCell.swapTile(adjCell, true);
            reset = false;
          }
        }
      }

      // in order to have a vertical swipe, we need that y distance is at least twice the x distance
      // and the amount of vertical distance is at least 10 pixels
      else if (Math.abs(distY) > Math.abs(distX) * 2 && Math.abs(distY) > 10) {
        if (distY > 0) {
          const adjCell = this.selectedCell.calculateAdjacentCells(null, 'up');

          if (adjCell!=null&&adjCell.tile.isBlank) {
            // console.log("BLANK TILE UP");
            this.selectedCell.swapTile(adjCell, true);
            reset = false;
          }
        }
        else {
          const adjCell = this.selectedCell.calculateAdjacentCells(null, 'down');

          if (adjCell!=null&&adjCell.tile.isBlank) {
            // console.log("BLANK TILE DOWN");
            this.selectedCell.swapTile(adjCell, true);
            reset = false;
          }
        }
      }
    }
    
    if(reset && this.selectedCell != null && this.selectedCell.tile != null) this.selectedCell.tile.scale = 1;
  }

  resetGrid(isInit) {
    gameData.shuffleCounter = gameData.initShuffleCounter;
    gameData.moves = 0;

    this.updateScore(true, isInit);

    this.disableNav();
    this.disableSwipe();

    for (let r = 0; r < this.grid.allTiles.length; r++) {
      if (this.grid.allTiles[r].char === ' ' || this.grid.allTiles[r].char === '') {
        this.grid.allTiles[r].keyBG.alpha = 1;
      }
    }

    this.playSound('shuffle_blocks');
    this.grid.randomizeGrid();
  }

  pauseGame() {
    this.playSound('click');
    gameData.gamePaused = true;

    this.disableNav();
    this.disableSwipe();

    this.popup = new Popup(this, 'pause');
    this.addToParent(this.popup, this);
  }

  resumeGame() {
    gameData.gamePaused = false;

    this.enableNav();
    this.enableSwipe();

    this.popup.destroy();
  }

  updateScore(reset, isInit) {
    if (reset) {
      this.moves.text = 0;
    }
    else {
      gameData.moves++;
      this.moves.text = gameData.moves;
    }

    this.grid.checkScore(isInit);

    this.moves.setScale(1.5, 1.5);

    this.addTween(this.moves, 250, { scaleX: 1, scaleY: 1 }, Phaser.Math.Easing.Linear);
  }

  gameOver() {
    console.log('GAME IS OVER YOU WIN!');

    this.disableNav();
    this.disableSwipe();

    if (gameData.bestMoves === 0) gameData.bestMoves = gameData.moves;
    else if (gameData.moves < gameData.bestMoves) gameData.bestMoves = gameData.moves;

    this.popup = new Popup(this, 'end');
    this.addToParent(this.popup, this);
  }

  cleanUp() {
    // console.log("going to level 1");
    this.disableNav();
    this.disableSwipe();

    this.grid.cleanUp();
    this.grid.destroy();
    this.moves.destroy();
    this.bg.destroy();
    this.resetBtn.destroy();
    this.helpBtn.destroy();

    if (this.popup) this.popup.destroy();

    gameData.moves = 0;
    gameData.shuffleCounter = gameData.initShuffleCounter;
    gameData.score = 0;

    this.scene.start('Intro');
  }
}